// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horizontal-menu-item {
  position: relative;
  width: 100%;
}
.horizontal-menu-item .mat-mdc-button,
.horizontal-menu-item [mat-button] {
  height: 64px;
  font-weight: 400;
  border-radius: 0;
  display: flex !important;
  align-items: center !important;
}
.horizontal-menu-item .mat-mdc-button.parent-item .mdc-button__label,
.horizontal-menu-item [mat-button].parent-item .mdc-button__label {
  display: flex;
  align-items: center;
  width: 100%;
}
.horizontal-menu-item .mat-mdc-button.parent-item .horizontal-menu-icon,
.horizontal-menu-item [mat-button].parent-item .horizontal-menu-icon {
  padding: 7px;
  border-radius: 50%;
}
.horizontal-menu-item .horizontal-menu-icon {
  margin-right: 8px;
}
.horizontal-menu-item .horizontal-sub-menu {
  position: absolute;
  width: 190px;
  max-height: 0;
  overflow: hidden;
  z-index: 2;
  transition: max-height 0.25s ease-out;
}
.horizontal-menu-item .horizontal-sub-menu .mat-mdc-button,
.horizontal-menu-item .horizontal-sub-menu [mat-button] {
  width: 100%;
  height: 36px;
}

.horizontal-menu-item:hover > .horizontal-sub-menu {
  max-height: 500px;
  overflow: visible;
}

.horizontal-sub-menu .horizontal-sub-menu {
  left: 100%;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/menu/horizontal-menu/horizontal-menu.component.scss","webpack://./src/app/theme/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACI,kBAAA;EACA,WAAA;AAHJ;AAII;;EAEI,YCHiB;EDIjB,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,8BAAA;AAFR;AAIY;;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AADhB;AAGY;;EACI,YAAA;EACA,kBAAA;AAAhB;AAII;EACI,iBAAA;AAFR;AAII;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EAGA,qCAAA;AAFR;AAGQ;;EAEI,WAAA;EACA,YAAA;AADZ;;AAKA;EACI,iBAAA;EACA,iBAAA;AAFJ;;AAIA;EACI,UAAA;EACA,MAAA;AADJ","sourcesContent":["// ==========================================================================\r\n// Component: Horizontal-menu.component\r\n// ==========================================================================\r\n@use \"../../../styles/variables\" as *;\r\n.horizontal-menu-item{\r\n    position: relative;\r\n    width: 100%;\r\n    .mat-mdc-button,\r\n    [mat-button]{\r\n        height: $horizontal-menu-height;\r\n        font-weight: 400;\r\n        border-radius: 0;\r\n        display: flex !important;\r\n        align-items: center !important;\r\n        &.parent-item{\r\n            .mdc-button__label{\r\n                display: flex;\r\n                align-items: center;\r\n                width: 100%;\r\n            }\r\n            .horizontal-menu-icon{\r\n                padding: 7px;\r\n                border-radius: 50%;\r\n            }\r\n        }\r\n    }\r\n    .horizontal-menu-icon{\r\n        margin-right: 8px;\r\n    }\r\n    .horizontal-sub-menu{\r\n        position: absolute;\r\n        width: 190px;\r\n        max-height: 0;\r\n        overflow: hidden;\r\n        z-index: 2;\r\n        -webkit-transition: max-height 0.25s ease-out;\r\n        -moz-transition: max-height 0.25s ease-out;\r\n        transition: max-height 0.25s ease-out;\r\n        .mat-mdc-button,\r\n        [mat-button]{\r\n            width: 100%;\r\n            height: 36px;\r\n        }\r\n    }\r\n}\r\n.horizontal-menu-item:hover > .horizontal-sub-menu{\r\n    max-height: 500px;\r\n    overflow: visible;\r\n}\r\n.horizontal-sub-menu .horizontal-sub-menu{\r\n    left: 100%;\r\n    top: 0;\r\n}\r\n","// ==========================================================================\r\n// Component: Variables\r\n// ==========================================================================\r\n$main-font-family: 'Roboto', sans-serif;\r\n\r\n$top-toolbar-height: 56px; \r\n$horizontal-menu-height: 64px; \r\n$footer-toolbar-height: 0px; \r\n//$footer-toolbar-height: 56px; \r\n\r\n$sidenav-width: 260px;\r\n$compact-sidenav-width: 170px;\r\n$mini-sidenav-width: 66px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
